// /kitchen-sink: the component inventory (interface foundation), wired by the shell directly (CONTRACTS.md 16).
import { createRoute, lazyRouteComponent, type AnyRoute } from '@tanstack/react-router'

export function kitchenSinkRoute(parent: AnyRoute): AnyRoute {
  return createRoute({
    getParentRoute: () => parent,
    path: '/kitchen-sink',
    component: lazyRouteComponent(() => import('./KitchenSink.tsx')),
  })
}
